module.exports = __webpack_public_path__ + "static/img/232_TO8_1979_og.11ea78c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/232_TO8_1979_og.jpg
// module id = 5f0u
// module chunks = 0